// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"SuccessMessage_modalWrapper__nqCoj","modalInfo":"SuccessMessage_modalInfo__3W4zB","message":"SuccessMessage_message__1BJxv","icon":"SuccessMessage_icon__ojngb"};